export default "__VITE_ASSET__LzFb1JOT__"